module.exports = "/_next/static/images/47f2f9898f13ef0634ef98c1d9a3f6f3-hero-experiment-lg.jpg";